import { useRef, useState } from 'react';

import set from 'lodash/set';
import useSWR from 'swr';
import { useDispatch } from 'react-redux';
import { useBuilder } from '~/app/lib/redux/selectors/builder-selector';
import { useDynamicGrid } from '~/app/lib/redux/selectors/dynamic-grid-selector';
import { updateComponent } from '~/app/components/dynamic-grid/dynamic-grid-helpers';

const WORDPRESS_API_URL = process.env.WP_MEDIA_GALLERY_URL;

const fetcher = (url: string) => fetch(url).then((res) => res.json());

export const useDynamicWpMedia = ({
  handleSelectImageSourceCallback,
  itemsPerPage = 21,
}: {
  handleSelectImageSourceCallback: ({
    imageUrl,
    imageSource,
  }: {
    imageUrl?: string;
    imageSource?: string;
  }) => void;
  itemsPerPage?: number;
}) => {
  const inputSearchRef = useRef<HTMLInputElement>(null);
  const dispatch = useDispatch();
  const { componentPath } = useDynamicGrid();
  const { flatOutline, selected: selectedComponentId } = useBuilder();
  const currentComponent = flatOutline?.[selectedComponentId];
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const { data: images, isLoading } = useSWR(
    `${WORDPRESS_API_URL}?page=${page}&per_page=${itemsPerPage}&media_type=image&search=${search}`,
    fetcher
  );

  const handleNext = () => {
    if (page < 10) {
      setPage(page + 1);
    }
  };

  const handlePrevious = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const handleImageClick = (image: any) => {
    set(currentComponent, `props.${componentPath}.imageUrl`, image?.source_url);
    dispatch(updateComponent(currentComponent));
    handleSelectImageSourceCallback({
      imageUrl: image?.source_url,
      imageSource: 'media-library',
    });
  };

  const handleSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const searchValue = inputSearchRef.current?.value;
    setSearch(searchValue || '');
  };

  return {
    inputSearchRef,
    handleSearch,
    handleNext,
    handlePrevious,
    handleImageClick,
    images,
    isLoading,
  };
};
